import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
  standalone: false,
})
export class ReadMoreComponent {
  @Input() text: string;
  @Input() size: string;

  readMore = false;
}
